// React 版的 Escape 分層：@/lib/escapeLayers 是從舊版原樣複製的堆疊（說明見該檔），這裡包成 hook。
// 浮層開啟期間註冊，Esc 只關最上層。effect 只依賴 active（close 存 ref），
// 符合 escapeLayers「註冊所在的 effect 只准追蹤開關狀態」的契約，否則重註冊會跳到棧頂、Esc 關錯層。
// 焦點還原（2026-10-13 拍板）：開啟當下記住焦點所在（通常是觸發鈕）；按 Esc 關掉後若焦點掉到 body
//（面板卸載把焦點帶走），還給觸發鈕。只走 Esc 這條路，滑鼠關閉不動焦點。
// 用 layout effect 記：子元件的聚焦 effect 多半在 passive effect 才跑，這時焦點還在觸發鈕上。
// autoFocus 例外（layout 階段前就聚焦）：傳 layerRef（浮層容器），焦點已在容器內時改用上一個失焦元素。
import { useEffect, useLayoutEffect, useRef } from 'react'
import { registerEscapeLayer } from '@/lib/escapeLayers'
import { focusBeforeOpen } from './usePanelFocus'

export function useEscapeLayer(active, close, layerRef) {
  const closeRef = useRef(close)
  useEffect(() => {
    closeRef.current = close
  })
  useLayoutEffect(() => {
    if (!active) return
    const opener = focusBeforeOpen(layerRef?.current)
    return registerEscapeLayer(() => {
      closeRef.current()
      requestAnimationFrame(() => {
        const cur = document.activeElement
        const lost = !cur || cur === document.body
        if (lost && opener instanceof HTMLElement && opener !== document.body && opener.isConnected) opener.focus({ preventScroll: true })
      })
    })
    // layerRef 是 ref 物件，參照固定；不能進依賴（重註冊會跳到棧頂）
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active])
}
